import {Accordion, AccordionSummary, Box, Typography} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import './DragAndDropItems.scss';
import {useState} from 'react';
import {CodingFormItem} from '../../../../shared/types';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import React from 'react';

export interface IOperatorItem {
  value?: string;
  label?: string;
  disabled?: boolean;
  [key: string]: string | number | boolean | undefined;
}

export type Items = {
  [x: string]: any;
  id: string;
  label: string;
  sequence: number;
  name?: string;
};

interface DragAndDropItemsProps {
  dargItems: Items;
  dargAllItems?: Items[];
  handleRemoveClick?: () => void;
  getUpdatedData?: (item: CodingFormItem) => void;
  dragHandleProps?: {
    role: string;
    tabIndex: number;
    'aria-disabled': boolean;
    'aria-pressed': boolean | undefined;
    'aria-roledescription': string;
    'aria-describedby': string;
    onKeyDown?: (event: React.KeyboardEvent) => void;
    onClick?: (event: React.MouseEvent) => void;
    onDragStart?: (event: React.DragEvent) => void;
  };
  ref?: (node: HTMLElement | null) => void;
  style?: {
    transform: string | undefined;
    transition: string | undefined;
  };
}

const DragAndDropItems: React.FC<DragAndDropItemsProps> = ({
  dragHandleProps,
  ref,
  style,
  dargItems,
  handleRemoveClick,
}) => {
  const [expand, setExpand] = useState<boolean>(false);

  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };

  return (
    <Box className={`dargdropItems-editor-main`} ref={ref} style={style}>
      <Accordion
        expanded={expand}
        aria-expanded={expand}
        data-testid={`dargdropItems-editor-accordian-${dargItems.id}`}
      >
        <Box
          className={`dargdropItems-editor-header ${!expand && 'header-border'}`}
        >
          <ArrIconButton
            icon={<MenuIcon data-testid={`menu-icon-drag-${dargItems.id}`} />}
            {...(dragHandleProps || {})}
            onClick={(e) => {
              e.stopPropagation();
              dragHandleProps?.onClick?.(e);
            }}
            ariaLabel="dragdrop"
            shape="default"
            size="small"
            testId={`drag-and-drop-accordion-items-${dargItems.id}`}
          />
          <AccordionSummary
            aria-controls="panel1-content"
            id="panel1-header"
            aria-label={dargItems?.label}
          >
            <Typography
              component="span"
              className="typo-text body3_size title-text"
              onClick={toggleAcordion}
              data-testid={`drag-and-drop-accordion-items-text-${dargItems.id}`}
            >
              {`${dargItems?.displayId.split('-')[0]}: ${dargItems.label} `}
            </Typography>
          </AccordionSummary>
          <ArrIconButton
            icon={
              <DeleteOutlineIcon data-testid={`delete-icon-${dargItems.id}`} />
            }
            onClick={() => {
              handleRemoveClick?.();
            }}
            ariaLabel="remove-form"
            shape="default"
            size="small"
            testId={`remove-icon-${dargItems.id}`}
          />
        </Box>
      </Accordion>
    </Box>
  );
};

export default React.memo(DragAndDropItems);
